// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-block__title{font-weight:var(--font-weight-semibold);line-height:1.5;margin-bottom:var(--spacing-tiny)}@media(min-width:1280px){.text-block__title{font-size:var(--font-size-default)}}.text-block__text{line-height:1.5}.text-block--narrow{display:flex;flex-direction:column;margin:0 auto;max-width:725px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
